import React from 'react'
import Service from '../components/home/Service'
import InquiryForm from '../pages/InquiryForm'
import { useState } from 'react'


const Services = () => {
    const [formData, setFormData] = useState({
        name: "",
        company:"",
        mobile:"",
        email: "",
        subject: "",
        message: "",
    });

    const [responseMessage, setResponseMessage] = useState("");

    // Handle input changes
    const handleChange = (e) => {
    const { name, value } = e.target;
      setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
          const response = await fetch("https://betalinkquate.ecomuntant.com/api/testformdata", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(formData),
          });
    
          if (response.ok) {
            setResponseMessage("Your inquiry has been submitted successfully!");
            setFormData({
                name: "",
                company:"",
                mobile:"",
                email: "",
                subject: "",
                message: "",
            });
          } else {
            setResponseMessage("Error submitting the inquiry. Please try again.");
          }
        } catch (error) {
          console.error("Error:", error);
          setResponseMessage("Something went wrong. Please try again.");
        }

    };

  return (
    <div className="App mt-5 mb-5">
        <Service/>
        <InquiryForm/>
    </div>
  )
}

export default Services;